'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import * as PlanType from 'ecosystem-marketplace-core/constants/pricings/PlanType';
import { storefrontCollection } from '../../../../constants/PropTypes';
import * as StorefrontCollection from '../../../../constants/StorefrontCollection';
import { getPlanTypeFilterI18nKey } from '../../../../utils/i18n';
import RadioInput from '../inputs/RadioInput';
const ALL = 'all';
const pricings = [ALL, PlanType.FREE, PlanType.MONTHLY, PlanType.YEARLY, PlanType.ONE_TIME, PlanType.METERED, PlanType.CONTACT_US];

const _getPlanTypeFilterI18nKey = value => {
  switch (value) {
    case ALL:
      return 'appMarketplace.storefront.filters.planType.items.all';

    default:
      return getPlanTypeFilterI18nKey(value);
  }
};

const PriceToggleGroup = ({
  activeCollection,
  onChange,
  value: inputValue
}) => {
  const freeCollectionIsActive = activeCollection === StorefrontCollection.FREE;
  return /*#__PURE__*/_jsx(UIToggleGroup, {
    name: "price",
    children: pricings.map(pricing => {
      let checked;

      if (freeCollectionIsActive) {
        checked = pricing === PlanType.FREE;
      } else {
        checked = inputValue ? pricing === inputValue : pricing === ALL;
      }

      return /*#__PURE__*/_jsx(RadioInput, {
        checked: checked,
        disabled: freeCollectionIsActive,
        onChange: ({
          target: {
            value
          }
        }) => onChange(value === ALL ? null : value),
        value: pricing,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: _getPlanTypeFilterI18nKey(pricing)
        })
      }, pricing);
    })
  });
};

PriceToggleGroup.propTypes = {
  activeCollection: storefrontCollection,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf(pricings)
};
export default PriceToggleGroup;